import { Component } from "react";
import { langCheck } from "Pub/js/utils";
import WidgetJSLoader from "Pages/NewHome/CreaterForWidget/WidgetJSLoader";
import { WidgetSidePath } from "Pub/js/constant";
import platform from "Pub/js/platform";
const { NCSwitch } = platform.base;

export default class GlobalSide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            widgetSide: null
        }
    }

    componentDidMount() {
        WidgetJSLoader(WidgetSidePath, key => {
            const widgetSide = window[key].default;
            if (widgetSide) {
                this.setState({
                    widgetSide
                });
            }
        });
    }

    render() {
        const { onClose, onChange } = this.props;
        const { widgetSide: WidgetSide } = this.state;
        const { sideData = {} } = this.props;
        const { showBackgroundImg } = sideData;
        return typeof WidgetSide === 'function'
            ?
            <WidgetSide
                maskClose={onClose}
                onClose={onClose}
                title="工作台设置"
            >
                <div className="common-widget-side">
                    <div className="side-item">
                        <span className="item-label name">
                            显示背景图
                            <NCSwitch checked={showBackgroundImg} onChange={val => {
                                onChange({ ...sideData, showBackgroundImg: val });
                            }}></NCSwitch>
                        </span>
                    </div>
                    {/* <div className="side-item">
                        <span className="item-label name">
                            显示样式
                            
                        </span>
                    </div> */}
                </div>
            </WidgetSide>
            :
            null
    }
}